import SolidityContract from '@exodus/solidity-contract';
import { UnitType } from '@exodus/currency';
import abi from '../abi.json';
import approveAbi from '../approve-abi.json';
class OnChainSwapsTransaction {
    _values;
    constructor(values) {
        this._values = values;
    }
    decodeInput() {
        const values = this._values.flatMap((value) => getValueFromDecodedTxInput(value));
        const [_requestId, fromToken, toToken, rawAmountIn, rawPlatformFee, rawDestinationExecutorFee, rawAffiliateFee, ...rest] = values;
        const currency = UnitType.create({ base: 0 });
        const amountIn = currency.baseUnit(rawAmountIn);
        const platformFee = currency.baseUnit(rawPlatformFee);
        const destinationExecutorFee = currency.baseUnit(rawDestinationExecutorFee);
        const affiliateFee = currency.baseUnit(rawAffiliateFee);
        const amountToTransfer = amountIn.add(platformFee).add(destinationExecutorFee).add(affiliateFee);
        return {
            receiver: rest[rest.length - 1],
            fromToken,
            toToken,
            amount: amountToTransfer.toBaseString({ unit: false }),
        };
    }
}
const getValueFromDecodedTxInput = (value) => {
    if (Array.isArray(value)) {
        return value.flatMap((value) => getValueFromDecodedTxInput(value));
    }
    if (typeof value === 'object' && typeof value._hex === 'string') {
        return [value._hex];
    }
    return [value];
};
const decodeTransaction = (rawTransactionInput, fromAddress) => {
    const contract = new SolidityContract(JSON.stringify(abi), fromAddress);
    const decodedInput = contract.decodeInput(rawTransactionInput);
    const transaction = new OnChainSwapsTransaction(decodedInput.values);
    return transaction.decodeInput();
};
export const getSpenderAddress = (rawTransactionInput, fromAddress) => {
    const contract = new SolidityContract(JSON.stringify(approveAbi), fromAddress);
    const decodedInput = contract.decodeInput(rawTransactionInput);
    const spenderAddress = decodedInput.values[0];
    return spenderAddress;
};
export default decodeTransaction;
